module.exports = "<symbol id=\"tt-icon-posts\" viewBox=\"0 0 24 24\"><path d=\"M10.71 3H3v18h18v-7.7H10.71zm2.58 1.8v5.9h5.9zm9.63 7.2h.66v9A2.67 2.67 0 0 1 21 23.58H3a2.46 2.46 0 0 1-1.84-.78A2.54 2.54 0 0 1 .42 21V3a2.54 2.54 0 0 1 .75-1.8A2.46 2.46 0 0 1 3 .42h9v.66l.6-.6L23.52 11.4z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"


//////////////////
// WEBPACK FOOTER
// ./src/build/VuTUYdwvqIExdDFsite/assets/svg/non-defined-page/posts.svg
// module id = 181
// module chunks = 11